import { QueryClient, QueryClientProvider, useQueryClient } from '@tanstack/react-query';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { ApiError, setCsrf, subscribeUnauthorized } from './api/client';
import { keys, useMe } from './api/hooks';
import { UIProvider } from './components/overlays';
import { LinkPage } from './LinkPage';
import { Login } from './Login';
import { Shell } from './Shell';
import './styles.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (n, e) => !(e instanceof ApiError && e.status < 500 && e.status !== 0) && n < 2,
    },
  },
});

function App() {
  const client = useQueryClient();
  const me = useMe();
  useEffect(
    () =>
      subscribeUnauthorized(() => {
        client.setQueryData(keys.me, null);
      }),
    [client],
  );
  useEffect(() => {
    if (me.data) setCsrf(me.data.csrfToken);
  }, [me.data]);
  const loc = useLocation();
  // ссылка приглашения или сброса пароля открывается и без входа
  if (/^\/(join|reset)\/?$/.test(loc.pathname)) return <LinkPage />;
  if (me.isPending) return null;
  if (!me.data) return <Login />;
  return (
    <UIProvider>
      <Shell />
    </UIProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
